module.exports = __webpack_public_path__ + "media/TABLE_TENNIS_Racket_Ball_Hit_07_Hard_mono.fd9b6a81.wav";